// client/src/components/catalogoModelo/ImportarCsvCatalogoModeloForm.js
import React, { useState } from 'react';
import { Download, Upload, Loader2 } from 'lucide-react';
import { useImportarCsvCatalogoModelo } from '../../hooks/useCatalogoModelo';
import ResultadoImportacaoTable from './ResultadoImportacaoTable';

const CABECALHO_MODELO = 'categoria,nome,tipo,segmento,imagem,preco,duracao,estoque,descricao';

const ImportarCsvCatalogoModeloForm = ({ onClose }) => {
    const importarCsv = useImportarCsvCatalogoModelo();

    const [csvFile, setCsvFile] = useState(null);
    const [imagensFiles, setImagensFiles] = useState([]);
    const [resultado, setResultado] = useState(null);

    const baixarModelo = () => {
        const blob = new Blob([`${CABECALHO_MODELO}\n`], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'modelo-catalogo.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!csvFile) return;

        const formData = new FormData();
        formData.append('csv', csvFile);
        imagensFiles.forEach((file) => formData.append('imagens', file));

        importarCsv.mutate(formData, {
            onSuccess: (data) => setResultado(data.data)
        });
    };

    return (
        <div>
            <div className="form-section">
                <h4 className="form-section-title">Importar Catálogo via CSV</h4>
                <p className="form-hint" style={{ marginBottom: 16 }}>
                    O CSV precisa das colunas <code>{CABECALHO_MODELO}</code>. A coluna
                    <code> imagem</code> deve ter o nome exato de um dos arquivos de imagem
                    selecionados abaixo — se não tiver arquivo correspondente, a linha é
                    importada sem imagem. Reenviar o mesmo CSV corrigido não duplica linhas
                    já importadas com sucesso.
                </p>

                <button type="button" onClick={baixarModelo} className="action-button action-button-secondary" style={{ marginBottom: 20 }}>
                    <Download size={18} className="icon" /> Baixar Modelo CSV
                </button>

                <form onSubmit={onSubmit}>
                    <div className="form-grid-container-cols-2">
                        <div className="form-group">
                            <label className="form-label required">Arquivo CSV</label>
                            <input
                                type="file"
                                accept=".csv,text/csv"
                                onChange={(e) => setCsvFile(e.target.files?.[0] || null)}
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Imagens (opcional, pode selecionar várias)</label>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={(e) => setImagensFiles(Array.from(e.target.files || []))}
                                className="form-input"
                            />
                            {imagensFiles.length > 0 && (
                                <p className="form-hint">{imagensFiles.length} imagem(ns) selecionada(s)</p>
                            )}
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="action-button action-button-secondary">
                            Fechar
                        </button>
                        <button type="submit" disabled={!csvFile || importarCsv.isPending} className="action-button action-button-primary">
                            {importarCsv.isPending ? <Loader2 size={18} className="icon animate-spin" /> : <Upload size={18} className="icon" />}
                            Importar
                        </button>
                    </div>
                </form>
            </div>

            {resultado && (
                <div className="form-section">
                    <h4 className="form-section-title">
                        Resultado — {resultado.totalCriados} criados, {resultado.totalDuplicados} duplicados, {resultado.totalErros} com erro
                        {' '}(de {resultado.totalLinhas} linhas)
                    </h4>
                    <ResultadoImportacaoTable resultados={resultado.resultados} extraColumn={{ key: 'linha', label: 'Linha' }} />
                </div>
            )}
        </div>
    );
};

export default ImportarCsvCatalogoModeloForm;
